import { View, Text, ScrollView, ImageBackground, Pressable, BackHandler } from 'react-native'
import React, { useEffect, useLayoutEffect, useState } from 'react'
import AsyncStorage from '@react-native-async-storage/async-storage';
import { useNavigation } from '@react-navigation/native'
import GlobalStyles from './../style';
import alert from './../alert';
import ttptr from './../teamsThatPlayThisRound';
import Partido from './../jugarPartido2';
import seasonTraining from '../seasonTraining';
import seasonDraft from '../seasonDraft'
import transl from '../translations/transl';
import allStats from '../allStats';
import nameSurname from '../namesSurnames';
import sortBestPlayers from '../sortBestPlayers';
import allStatsForGame from '../allStatsForGame';
import dr from './../datosReferenciales.json'
import { useSelector } from 'react-redux'

let partidoJugado = false;
let finalInfo = [<View key="loading" style={{flex:1, justifyContent:'center'}}><View><Text>Loading...</Text></View></View>]
let marcadorMemoria = "0 - 0"
let posicionFinalEnLiga = 19
let seasonHasBeenReset = false
let lang = undefined
let isTripleCrowned = false
let addButtonStats = false
let estadisticasFinal = []

const NextMatch = ({route}) => {
  let thisActualGame = route.params
  let backButtonPressSubscription;
  useEffect(() => {
    // Add a listener to the back button press event
    backButtonPressSubscription = BackHandler.addEventListener(
      'hardwareBackPress',
      () => {
        // Prevent the default back button behavior (exiting the app)
        return true;
      }
    );
    // Return a function that removes the listener
    return () => {
      backButtonPressSubscription.remove();
    };
  }, []);

  //taking of the header and stuff
  const navigation = useNavigation();
  useLayoutEffect(() => {
    navigation.setOptions({
        headerShown: false,
        headerTitle: "Match"
    })
  }, []);
  
  //receivedData
  const [value, setvalue] = useState('');
  const readValue = () => {
    AsyncStorage.getItem('equipos')
    .then((value)=> {
      setvalue(value)
    })
  }
  readValue();

  lang = dr.idiomas[useSelector((state) => state.language)].value

  //trying to wait
  const [counter, setCounter] = React.useState(0);
  React.useEffect(() => {
    let time = 50
    if(value != "" && value != null) {
      let data = value
      data = data != null ? JSON.parse(data) : null
      time = time + data.settings.comentarySpeed*100
    }
    const interval = setInterval(() => {
      setCounter(counter + 1);
    }, time);
    return () => clearInterval(interval);
  }, [counter]);

  let comentary = displayInfo(value,thisActualGame)

  if (!addButtonStats && comentary) {
    comentary.push(<View style={{marginBottom:25}}>
      <Pressable
        style={GlobalStyles.buttonMatchStats}
        onPress={() => seeStats()}>
        <Text style={GlobalStyles.textForButtonMain}>{transl('NextMatch.estadisticasPartido',lang)}</Text>
      </Pressable>
    </View>)
    addButtonStats = true
  }

  //trying to scroll...
  const scrollViewRef = React.useRef(null);
  React.useEffect(() => {
    if (scrollViewRef.current && counter < comentary.length) {
      scrollViewRef.current.scrollToEnd({ animated: true });
    }
  }, [counter]);

  let miniParse = undefined
  if(!(value === undefined || !value)){
    miniParse = value != null ? JSON.parse(value) : null
  }

  let buttonDissabled = true
  if(comentary != undefined && comentary[0].props.children != "Loading..." && counter > comentary.length) {
    buttonDissabled = false
  } else if (comentary != undefined && comentary[0].props.children != "Loading..." && miniParse != undefined && miniParse.settings.backButtonAbled) {
    buttonDissabled = false;
  }

  let marcador = "0 - 0"
  if(comentary != undefined && comentary[counter] != undefined && comentary[0].props.children != "Loading..." && !isNaN(comentary[counter].props.children[0]) && comentary[counter].props.children[2] != undefined) {
    marcador = comentary[counter].props.children[0] + " - " + comentary[counter].props.children[2]
    marcadorMemoria = marcador;
    //si borramos esta linea, se mostrara el marcador en directo
    comentary.splice(counter,1)
  } else marcador = marcadorMemoria

  let nameMyTeam = "", nameEnemyTeam = ""
  if(comentary != undefined && comentary[0].props.children != "Loading...") {
    nameMyTeam = comentary[0].props.children[0]
    nameEnemyTeam = comentary[0].props.children[2]
  }

  if(comentary != undefined) return (
    <View style={{height:'100%'}}>
      <ImageBackground source={require('./../img/campoFondo.png')} resizeMode="cover" style={{flex:1,justifyContent:'center'}}>
        <ScrollView style={styles.scrollView} ref={scrollViewRef}>
          {/* {counter} */}
          {/* Esta linea deberia imprimir tal cual la info del partido */}
          {/* <Text style={{marginTop:25}}>{useMemo(() => displayInfo(value))}</Text> */}
          <View>
            {/* {comentary.slice(0, counter + 1).map((item) => (
              <Text>{ item }</Text>
            ))} */}
            { comentary.slice(0, counter + 1).map((comentary, index) => <View key={index}>{comentary}</View>) }
          </View>
        </ScrollView>
      </ImageBackground>
      
      <View style={{flexDirection: 'row', justifyContent: 'space-between'}}>
        <Text style={{flexGrow:1, textAlign: 'left', marginLeft: 20}}>{nameMyTeam}</Text>
        <Text style={styles.matchScoreboard}>{marcador}</Text>
        <Text style={{flexGrow:1, textAlign: 'right', marginRight: 20}}>{nameEnemyTeam}</Text>
      </View>
      <View style={GlobalStyles.buttonFixedDown}>
        <Pressable
          disabled={buttonDissabled}
          style={buttonDissabled ? GlobalStyles.buttonMatchDisabled : GlobalStyles.buttonMatch}
          onPress={() => gameEnded()}
          onLongPress={() => printRestOfGame()}
          onPressOut={() => scrollDown()}
          >
          <Text style={GlobalStyles.textForButtonMain}>{transl('NextMatch.terminar',lang)}</Text>
        </Pressable>
      </View>
    </View>
  )
  else return(<View style={{flex:1, justifyContent:'center'}}><Text style={{textAlign:'center',fontWeight:'bold',fontSize:42}}>{transl('General.cargando',lang)}</Text></View>)

  function gameEnded() {
    partidoJugado = false;
    addButtonStats = false;
    marcadorMemoria = "0 - 0"
    navigation.navigate('MainMenu')
    navigation.navigate('HomeScreen')
    if(seasonHasBeenReset) {
      //si entra aqui significa que el siguiente partido será nueva temporada
      if(isTripleCrowned){
        alert("ENHORABUENA","Has ganado la Triple Corona de Quedepp",[
          {text: "CREDITOS", onPress: () => {
            navigation.navigate('HomeScreen')
            navigation.navigate('Credits')
          }, style: "cancel"}
        ])
      }
      alert("¡Temporada finalizada!", "Posicion en Liga: "+(posicionFinalEnLiga+1)+"º", [
        {text: "OK", onPress: () => void(0), style: "cancel"}
      ])
    }
    //TODO else if para ver que mensaje sacamos en copa (pasado de ronda, eliminado, ganada la final, subcampeon...)
  }

  function printRestOfGame() {
    if (counter < comentary?.length) {
      setCounter(comentary?.length)
    }
  }

  function scrollDown() {
    scrollViewRef.current.scrollToEnd({ animated: true });
  }

  function seeStats() {
    navigation.navigate('InGameStats',estadisticasFinal)
  }

  function asignarNuevasCopas(passedData){
    let data = passedData

    const tableData = [];
    const theTeams = data.teams;
    for (const element of theTeams) {
      const rowData = [];
      rowData.push(element.points)
      rowData.push(element.tantosF - element.tantosC)
      rowData.push(element.partidosGanados)
      rowData.push(element.tantosF)
      rowData.push(element.id)
      tableData.push(rowData);
    }
    let sortedTableData = tableData.sort(comparePoints)
    const temporadaVerdadera = Math.floor(data.others.vecesTodosLosPartidosHechos/2)

    //vamos a ver las copas ganadas, y vamos a dar premios por ellas
    let tripleCrown = [false,false,false]
    if(checkCupFinalClasi(data.others.championships.spanishCup) == 0){
      //campeon copa españa
      data.profile.money += 1000
      data.others.trophies.push({season:temporadaVerdadera,icon:1,date:new Date(),cupType:1})
      tripleCrown[0] = true;
      data.profile.grageas += 10
    } else if (checkCupFinalClasi(data.others.championships.spanishCup) == 1){
      data.profile.money += 500
      data.profile.grageas += 3
      data.others.trophies.push({season:temporadaVerdadera,icon:2,date:new Date(),cupType:1})
    }
    if(checkCupFinalClasi(data.others.championships.losersCup) == 0){
      data.profile.money += 5000
      data.profile.grageas += 3
      data.others.trophies.push({season:temporadaVerdadera,icon:1,date:new Date(),cupType:2})
    } else if (checkCupFinalClasi(data.others.championships.losersCup) == 1){
      data.profile.money += 3000
      data.profile.grageas += 3
      data.others.trophies.push({season:temporadaVerdadera,icon:2,date:new Date(),cupType:2})
    }
    if(checkCupFinalClasi(data.others.championships.worldCup) == 0){
      data.profile.money += 3000
      data.others.trophies.push({season:temporadaVerdadera,icon:1,date:new Date(),cupType:3})
      tripleCrown[1] = true;
      data.profile.grageas += 10
    } else if (checkCupFinalClasi(data.others.championships.worldCup) == 1){
      data.profile.money += 1500
      data.profile.grageas += 3
      data.others.trophies.push({season:temporadaVerdadera,icon:2,date:new Date(),cupType:3})
    }
    if(checkCupFinalClasi(data.others.championships.europeanCup) == 0){
      data.profile.money += 2000
      data.others.trophies.push({season:temporadaVerdadera,icon:1,date:new Date(),cupType:4})
      tripleCrown[2] = true;
      data.profile.grageas += 10
    } else if (checkCupFinalClasi(data.others.championships.europeanCup) == 1){
      data.profile.money += 1000
      data.profile.grageas += 3
      data.others.trophies.push({season:temporadaVerdadera,icon:2,date:new Date(),cupType:4})
    }
    if(checkCupFinalClasi(data.others.championships.superCup) == 0){
      data.profile.money += 500
      data.others.trophies.push({season:temporadaVerdadera,icon:1,date:new Date(),cupType:5})
      data.profile.grageas += 2
    } else if (checkCupFinalClasi(data.others.championships.superCup) == 1){
      data.profile.money += 200
      data.profile.grageas += 1
      data.others.trophies.push({season:temporadaVerdadera,icon:2,date:new Date(),cupType:5})
    }

    if(tripleCrown[0] && tripleCrown[1] && tripleCrown[2]){
      data.others.trophies.push({season:temporadaVerdadera,icon:4,date:new Date(),cupType:6})
      data.profile.grageas += 50
      data.profile.money += 50000
      isTripleCrowned = true;
    }

    data.profile.grageas += 3
    
    let posicionFinalEnLiga = 0

    for(let i = 0; i < sortedTableData.length; i++){
      if(i < 16){
        //reset spanishcup
        data.others.championships.spanishCup.equipos[i].id = sortedTableData[i][4]
        data.others.championships.spanishCup.equipos[i].results = []
        data.others.championships.spanishCup.currentRound = 0
      } else {
        data.others.championships.losersCup.equipos[i-16].id = sortedTableData[i][4]
        data.others.championships.losersCup.equipos[i-16].results = []
        data.others.championships.losersCup.currentRound = 0
      }
      if(i < 4){
        data.others.championships.worldCup.equipos[i].id = sortedTableData[i][4]
        data.others.championships.worldCup.equipos[i].results = []
        data.others.championships.worldCup.currentRound = 0
      }
      if(i < 8){
        data.others.championships.europeanCup.equipos[i].id = sortedTableData[i][4]
        data.others.championships.europeanCup.equipos[i].results = []
        data.others.championships.europeanCup.currentRound = 0
      }
      if(i < 2){
        data.others.championships.superCup.equipos[i].id = sortedTableData[i][4]
        data.others.championships.superCup.equipos[i].results = []
        data.others.championships.superCup.currentRound = 0
      }

      if(sortedTableData[i][4] == 1) posicionFinalEnLiga = i
    }
    data.others.championships.spanishCup.equipos = shuffle(data.others.championships.spanishCup.equipos)
    data.others.championships.losersCup.equipos = shuffle(data.others.championships.losersCup.equipos)
    data.others.championships.worldCup.equipos = shuffle(data.others.championships.worldCup.equipos)
    data.others.championships.europeanCup.equipos = shuffle(data.others.championships.europeanCup.equipos)

    for(let i = 0; i < sortedTableData.length; i++){
      if(i < 16 && data.others.championships.spanishCup.equipos[i].id == 1){
        data.others.championships.spanishCup.equipos = swapElements(data.others.championships.spanishCup.equipos,i,0)
      }
      if(i >= 16 && data.others.championships.losersCup.equipos[i-16].id == 1){
        data.others.championships.losersCup.equipos = swapElements(data.others.championships.losersCup.equipos,i-16,0)
      }
      if(i < 4 && data.others.championships.worldCup.equipos[i].id == 1){
        data.others.championships.worldCup.equipos = swapElements(data.others.championships.worldCup.equipos,i,0)
      }
      if(i < 8 && data.others.championships.europeanCup.equipos[i].id == 1){
        data.others.championships.europeanCup.equipos = swapElements(data.others.championships.europeanCup.equipos,i,0)
      }
      if(i < 2 && data.others.championships.superCup.equipos[i].id == 1){
        data.others.championships.superCup.equipos = swapElements(data.others.championships.superCup.equipos,i,0)
      }
    }

    let galeonesGanadosEnFinalLiga = 100;
    if(posicionFinalEnLiga < 10) galeonesGanadosEnFinalLiga += 200
    if(posicionFinalEnLiga < 6) galeonesGanadosEnFinalLiga += 300
    if(posicionFinalEnLiga < 3) {
      galeonesGanadosEnFinalLiga += 400
      if(posicionFinalEnLiga == 2)data.others.trophies.push({season:temporadaVerdadera,icon:3,date:new Date(),cupType:7})
      data.profile.grageas += 1
    }
    if(posicionFinalEnLiga < 2) {
      galeonesGanadosEnFinalLiga += 300
      if(posicionFinalEnLiga == 1)data.others.trophies.push({season:temporadaVerdadera,icon:2,date:new Date(),cupType:7})
      data.profile.grageas += 2
    }
    if(posicionFinalEnLiga == 0) {
      galeonesGanadosEnFinalLiga += 400
      data.others.trophies.push({season:temporadaVerdadera,icon:1,date:new Date(),cupType:7})
      data.profile.grageas += 3
    }

    data.profile.money += galeonesGanadosEnFinalLiga

    //vamos a mirar los trofeos de los mejores jugadores de la temporada
    //TODO
    //jornada real siempre 38, ya que si llega aquí es final de temporada
    let updatedPlayers = [];
		data.teams.forEach((team) => {
			team.players.forEach(player => {
				updatedPlayers.push({
					...player,
					team: team.name,
					teamId: team.id
				});
			});
		});

    //primer hueco es cantidad, segundo name, tercero age, y cuarto el objeto como tal
    let infoTrofeos = []

    const mejoresQuaffle = sortBestPlayers(updatedPlayers, 1, 38)
    const mejoresCazador = sortBestPlayers(updatedPlayers, 2, 38)
    const mejoresReboteador = sortBestPlayers(updatedPlayers, 3, 38)
    const mejoresProgresos = sortBestPlayers(updatedPlayers, 12, 38)
    const mejoresZamora = sortBestPlayers(updatedPlayers, 4, 38)
    const mejoresAros = sortBestPlayers(updatedPlayers, 5, 38)
    const mejoresBuscador = sortBestPlayers(updatedPlayers, 6, 38)
    const mejoresBate = sortBestPlayers(updatedPlayers, 7, 38)
    const mejoresEscoba = sortBestPlayers(updatedPlayers, 8, 38)
    const mejoresMvp = sortBestPlayers(updatedPlayers, 10, 38)
    const mejoresKopa = sortBestPlayers(updatedPlayers, 11, 38)
    for (let i = 0; i < 3; i++) {
      if (mejoresQuaffle[i] && mejoresQuaffle[i].teamId == 1) {
        data.others.trophies.push({season:temporadaVerdadera,icon:i+1,date:new Date(), cupType: 9,player:mejoresQuaffle[i].name,age:mejoresQuaffle[i].age})
        if(i == 0) infoTrofeos = sumTrophyToPlayer(infoTrofeos, mejoresQuaffle[i])
      }
      if (mejoresCazador[i] && mejoresCazador[i].teamId == 1) {
        data.others.trophies.push({season:temporadaVerdadera,icon:i+1,date:new Date(), cupType: 10,player:mejoresCazador[i].name,age:mejoresCazador[i].age})
        if(i == 0) infoTrofeos = sumTrophyToPlayer(infoTrofeos, mejoresCazador[i])
      }
      if (mejoresReboteador[i] && mejoresReboteador[i].teamId == 1) {
        data.others.trophies.push({season:temporadaVerdadera,icon:i+1,date:new Date(), cupType: 11,player:mejoresReboteador[i].name,age:mejoresReboteador[i].age})
        if(i == 0) infoTrofeos = sumTrophyToPlayer(infoTrofeos, mejoresReboteador[i])
      }
      if (mejoresProgresos[i] && mejoresProgresos[i].teamId == 1) {
        data.others.trophies.push({season:temporadaVerdadera,icon:i+1,date:new Date(), cupType: 20,player:mejoresProgresos[i].name,age:mejoresProgresos[i].age})
        if(i == 0) infoTrofeos = sumTrophyToPlayer(infoTrofeos, mejoresProgresos[i])
      }
      if (mejoresZamora[i] && mejoresZamora[i].teamId == 1) {
        data.others.trophies.push({season:temporadaVerdadera,icon:i+1,date:new Date(), cupType: 12,player:mejoresZamora[i].name,age:mejoresZamora[i].age})
        if(i == 0) infoTrofeos = sumTrophyToPlayer(infoTrofeos, mejoresZamora[i])
      }
      if (mejoresAros[i] && mejoresAros[i].teamId == 1) {
        data.others.trophies.push({season:temporadaVerdadera,icon:i+1,date:new Date(), cupType: 13,player:mejoresAros[i].name,age:mejoresAros[i].age})
        if(i == 0) infoTrofeos = sumTrophyToPlayer(infoTrofeos, mejoresAros[i])
      }
      if (mejoresBuscador[i] && mejoresBuscador[i].teamId == 1) {
        data.others.trophies.push({season:temporadaVerdadera,icon:i+1,date:new Date(), cupType: 14,player:mejoresBuscador[i].name,age:mejoresBuscador[i].age})
        if(i == 0) infoTrofeos = sumTrophyToPlayer(infoTrofeos, mejoresBuscador[i])
      }
      if (mejoresBate[i] && mejoresBate[i].teamId == 1) {
        data.others.trophies.push({season:temporadaVerdadera,icon:i+1,date:new Date(), cupType: 15,player:mejoresBate[i].name,age:mejoresBate[i].age})
        if(i == 0) infoTrofeos = sumTrophyToPlayer(infoTrofeos, mejoresBate[i])
      }
      if (mejoresEscoba[i] && mejoresEscoba[i].teamId == 1) {
        data.others.trophies.push({season:temporadaVerdadera,icon:i+1,date:new Date(), cupType: 16,player:mejoresEscoba[i].name,age:mejoresEscoba[i].age})
        if(i == 0) infoTrofeos = sumTrophyToPlayer(infoTrofeos, mejoresEscoba[i])
      }
      if (mejoresMvp[i] && mejoresMvp[i].teamId == 1) {
        data.others.trophies.push({season:temporadaVerdadera,icon:i+1,date:new Date(), cupType: 17,player:mejoresMvp[i].name,age:mejoresMvp[i].age})
        if(i == 0) infoTrofeos = sumTrophyToPlayer(infoTrofeos, mejoresMvp[i])
      }
      if (mejoresKopa[i] && mejoresKopa[i].teamId == 1) {
        data.others.trophies.push({season:temporadaVerdadera,icon:i+1,date:new Date(), cupType: 18,player:mejoresKopa[i].name,age:mejoresKopa[i].age})
        if(i == 0) infoTrofeos = sumTrophyToPlayer(infoTrofeos, mejoresKopa[i])
      }
    }

    //
    console.log(infoTrofeos)
    infoTrofeos.forEach(number => {
      if (number[0] >= 3) {
        data.others.trophies.push({season:temporadaVerdadera,icon:4,date:new Date(), cupType: 19,player:number[1].name,age:number[1].age})
      }
    })
     
    

    //vamos a resetear la liga, y nuestras estadisticas
    for(let i = 0; i < data.teams.length; i++){
      //reseteamos estadisticas
      for(let j = 0; j < data.teams[i].players.length; j++){
        data.teams[i].players[j].stats = allStats()
        data.teams[i].players[j].inGameStats = allStatsForGame()
        data.teams[i].players[j].injury = 0;
        if(i != 0 && data.teams[i].players[j].age > 28) {
          data.teams[i].players[j].age = Math.floor(Math.random() * (4) + 20)
          data.teams[i].players[j].name = nameSurname()
          //si hay cambio de jugador, tambien cambiamos un poco las habilidades
          for(let k = 0; k < data.teams[i].players[j].skills.length; k++){
            data.teams[i].players[j].skills[k] += Math.floor(Math.random() * (20) + (-10))
            if(data.teams[i].players[j].skills[k] > 99) data.teams[i].players[j].skills[k] = 99
            else if(data.teams[i].players[j].skills[k] < 1) data.teams[i].players[j].skills[k] = 1
          }
        } else data.teams[i].players[j].age++
      }
      data.teams[i].partidosGanados = 0;
      data.teams[i].partidosPerdidos = 0;
      data.teams[i].points = 0;
      data.teams[i].tantosC = 0;
      data.teams[i].tantosF = 0;
    }

    return [data,posicionFinalEnLiga]
  }
  function comparePoints(a,b){
    if(a[0] > b[0]) return -1
    if(a[0] < b[0]) return 1
    if(a[0] == b[0]) {
      if(a[1] > b[1]) return -1
      if(a[1] < b[1]) return 1
      if(a[1] == b[1]) {
        if(a[2] > b[2]) return -1
        if(a[2] < b[2]) return 1
        if(a[2] == b[2]) {
          if(a[3] > b[3]) return -1
          if(a[3] < b[3]) return 1
          return 0
        }
        return 0
      }
      return 0
    }
    return 0
  }
  function shuffle(array) {
    let currentIndex = array.length,  randomIndex;
    while (currentIndex != 0) {
      randomIndex = Math.floor(Math.random() * currentIndex);
      currentIndex--;
      [array[currentIndex], array[randomIndex]] = [
        array[randomIndex], array[currentIndex]];
    }
    return array;
  }
  function swapElements(array, source, dest) {
    const b = array[source];
    array[source] = array[dest];
    array[dest] = b;
    return array
  }
  function checkCupFinalClasi(cup) {
    if(cup.equipos[0].id == 1) {
      //participamos en la copa
      let indicesEnCopa = ttptr(cup)
      
      if(cup.equipos[indicesEnCopa[0]].id == 1) return 0

      //ahora comprobamos que no haya quedado segundo
      if(indicesEnCopa.length == 1) return 1
    }
    return -1
  }
  function sumTrophyToPlayer (infoTrofeos, mej) {
    const index = infoTrofeos.findIndex(info => info[1] === mej)

    if (index !== -1) {
      infoTrofeos[index][0]++
    } else {
      infoTrofeos.push([1,mej])
    }

    return infoTrofeos
  }

  function displayInfo(data,thisActualGame) {
    //we arrive here after our JSON file is loaded, here we should do the match
    if(data === undefined || !data) return
    data = data != null ? JSON.parse(data) : null
    //data parsed sucessfully
  
    if(partidoJugado) return finalInfo
  
    console.log("Se juega el partido")
    partidoJugado = true;
    let infoToSend = [];

    if (thisActualGame.name == 'multijugador') {
      let info = [];
      let puntuacion = [0,0];
      let estadisticas;

      //buscamos el equipo
      const friendTeam = data.multiplayer.teams.find(element => element.info.uuid == thisActualGame.teamUuid)
      //metemos nuevo equipo en posicion 21 y metemos el equipo amigo, referenciamos el id, jugamos patido, y al salir eliminamos el equipo amigo

      let friendTeamParsed = friendTeam.players.map(player => ({
        name: player.name,
        skills: player.skills,
        broom: player.broom,
        hiddenSkills: player.hiddenSkills,
        age: player.age ? player.age : 25,
        stats: allStats(),
        inGameStats: allStatsForGame(),
        injury: 0,
        nickname: ''
      }))

      data.teams.push({
        id: 21,
        name: friendTeam.info.teamName,
        partidosGanados: 0,
        partidosPerdidos: 0,
        players: friendTeamParsed,
        points: 0,
        tantosC: 0,
        tantosF: 0
      });

      console.log("antes del partido")

      [data, info, puntuacion, estadisticas] = playAnyMatch(data,data.teams[0].id,data.teams[20].id, {state:3})

      finalInfo = info;
      return info;
    }
  
    if(thisActualGame.name != 'liga'){
      infoToSend.push(<Text>Loading...</Text>)
  
      let info = [];
      let puntuacion = [0,0];
      let estadisticas;
  
      //nos dan igual los ids de los equipos, tenemos que jugar todos los partidos de la ronda
      const cpa = data.others.championships[thisActualGame.name];
      const rondaActual = Math.floor(cpa.currentRound / cpa.gamesPerRound)
      const partidosQueSeJuegan = cpa.equipos.length / (2 ** (rondaActual+1))
  
      //vamos a calcular los partidos que se juegan, esto incluye
      const equipos = cpa.equipos;
  
      let indicesDeLosGanadores = ttptr(cpa)
  
  
      for(let i = 0; i < partidosQueSeJuegan; i++){
        [data, info, puntuacion, estadisticas] = playAnyMatch(data,equipos[indicesDeLosGanadores[i*2]].id,equipos[indicesDeLosGanadores[(i*2)+1]].id,{state:2})

        equipos[indicesDeLosGanadores[i*2]].results.push([puntuacion[0]])
        equipos[indicesDeLosGanadores[(i*2)+1]].results.push([puntuacion[1]])
        if(indicesDeLosGanadores[i]==0) {
          infoToSend = info
          data.profile.money += 15
          if(puntuacion[0]>puntuacion[1]) data.profile.money += 5
        }
      }
      cpa.currentRound += 1
    } else {
      //jugando liga
      //se juegan paralelamente 9 partidos
      //necesitamos hacerlo grafico para que se entienda, ya optimizaremos la creacion de estas arrays en el futuro
      let array1 = [data.teams[0],data.teams[1],data.teams[2],data.teams[3],data.teams[4],data.teams[5],data.teams[6],data.teams[7],data.teams[8],data.teams[9]]
      let array2 = [data.teams[10],data.teams[11],data.teams[12],data.teams[13],data.teams[14],data.teams[15],data.teams[16],data.teams[17],data.teams[18],data.teams[19]]
  
      //les damos tantas vueltas como nos diga .siguientePartido
      //si acabamos de empezar y solo hay uno, esto no deberia dar ninguna vuelta
      //la cuestion es cuantas veces hacemos esto
      const sp = data.others.siguientePartido
      for(let i = 1; i < sp; i++){
        const arrayGuardada = Object.assign({}, array2[0])
  
        array2[0] = array2[1]
        array2[1] = array2[2]
        array2[2] = array2[3]
        array2[3] = array2[4]
        array2[4] = array2[5]
        array2[5] = array2[6]
        array2[6] = array2[7]
        array2[7] = array2[8]
        array2[8] = array2[9]
  
        array2[9] = array1[9]
      
        array1[9] = array1[8]
        array1[8] = array1[7]
        array1[7] = array1[6]
        array1[6] = array1[5]
        array1[5] = array1[4]
        array1[4] = array1[3]
        array1[3] = array1[2]
        array1[2] = array1[1]
  
        array1[1] = arrayGuardada
      }
  
      let info = [];
      let puntuacion = [0,0];
      let estadisticas
  
      let myTeamEnemy = data.others.siguientePartido
      if(myTeamEnemy > 10) {
        myTeamEnemy = myTeamEnemy - 11
        myTeamEnemy = -myTeamEnemy
      }
  
      //se suma 10 en vez de 9 porque dentro de la funcion se resta uno (por el tema del id desfasado)
      const partidosQueSeJuegan = 10;
      for(let i = 0; i < partidosQueSeJuegan; i++){
        //el partido que nuestro equipo juega siempre es el array1[0],array2[0]
        [data, info, puntuacion, estadisticas] = playAnyMatch(data,array1[i].id,array2[i].id,{state:1})

        data = sumPointsInLeague(data,array1[i].id,array2[i].id,puntuacion[0],puntuacion[1])
        if(i==0) {
          estadisticasFinal = estadisticas
          infoToSend = info
          data.profile.money += 10
          if(puntuacion[0]>puntuacion[1]) data.profile.money += 15
        }
      }
    }
    
    if(data.others.siguientePartido == 1 && data.others.vecesTodosLosPartidosHechos%2 == 0 && (data.teams[0].tantosF != 0 || data.teams[0].tantosC != 0)){
      data = seasonTraining(data)
      let resultCopas = asignarNuevasCopas(data)
      data = resultCopas[0]
      posicionFinalEnLiga = resultCopas[1]
      data = seasonDraft(data,posicionFinalEnLiga)
      seasonHasBeenReset = true;
    } else {
      seasonHasBeenReset = false;
    }

    saveGameInfo(data)

    finalInfo = infoToSend;
  
    return infoToSend
  }
}

function playAnyMatch(data,team1Id,team2Id, friendly = {state:0}){
  let info = [];
  let puntuacion = [0,0];
  let estadisticas;

  const resultado = Partido(data, team1Id, team2Id, lang, friendly);
  [data, info, puntuacion, estadisticas] = resultado;

  return [data,info,puntuacion, estadisticas];
}

function sumPointsInLeague(data,id1,id2,points1,points2) {
  if(points1 > points2){
    data.teams[id1-1].partidosGanados = data.teams[id1-1].partidosGanados + 1
    data.teams[id2-1].partidosPerdidos = data.teams[id2-1].partidosPerdidos + 1

    data.teams[id1-1].points = data.teams[id1-1].points + 2
    if(points1 > (points2 + 50)) {
      data.teams[id1-1].points = data.teams[id1-1].points + 1
    }
    if(points1 > (points2 + 100)) {
      data.teams[id1-1].points = data.teams[id1-1].points + 2
    }
    if(points1 > (points2 + 150)) {
      data.teams[id1-1].points = data.teams[id1-1].points + 2
    }


  } else if (points1 < points2) {
    data.teams[id2-1].partidosGanados = data.teams[id2-1].partidosGanados + 1
    data.teams[id1-1].partidosPerdidos = data.teams[id1-1].partidosPerdidos + 1

    data.teams[id2-1].points = data.teams[id2-1].points + 2
    if(points2 > (points1 + 50)) data.teams[id2-1].points = data.teams[id2-1].points + 1
    if(points2 > (points1 + 100)) data.teams[id2-1].points = data.teams[id2-1].points + 2
    if(points2 > (points1 + 150)) data.teams[id2-1].points = data.teams[id2-1].points + 2
  }
  
  data.teams[id1-1].tantosF = points1 + data.teams[id1-1].tantosF;
  data.teams[id1-1].tantosC = points2 + data.teams[id1-1].tantosC;

  data.teams[id2-1].tantosF = points2 + data.teams[id2-1].tantosF;
  data.teams[id2-1].tantosC = points1 + data.teams[id2-1].tantosC;

  if(id1 == 1){
    if(data.others.siguientePartido < 19)data.others.siguientePartido += 1;
    else {
      data.others.siguientePartido = 1
      data.others.vecesTodosLosPartidosHechos = data.others.vecesTodosLosPartidosHechos + 1
      //redirigir a pagina de fin de liga
    }
  }

  //checkear jugadores lesionados, y restarles uno, pues ha acabado una jornada
  for(let i = 0; i < data.teams[id1-1].players.length; i++){
    if(data.teams[id1-1].players[i].injury > 0) data.teams[id1-1].players[i].injury -= 1
  }
  for(let i = 0; i < data.teams[id2-1].players.length; i++){
    if(data.teams[id2-1].players[i].injury > 0) data.teams[id2-1].players[i].injury -= 1
  }


  return data
}

function saveGameInfo(data) {
  //update file
  const storeData = async (data) => {
    try {
      const jsonValue = JSON.stringify(data)
      await AsyncStorage.setItem('equipos', jsonValue)
    } catch (e) {
      console.log("error saving file")
      console.log(e)
    }
  }

  storeData(data);

  return;
}

const styles = {
  scrollView: {
    marginHorizontal: 5
  },
  matchScoreboard: {
    fontWeight: 'bold',
    fontSize: 16,
    textAlign: 'center'
  }
};


export default NextMatch